module.exports = __webpack_public_path__ + "img/pos_tag_10_quoted.45b32796.png";